import AuthModal from "@/components/auth/AuthModal";
import Header from "@/components/layout/Header";
import FilterSidebar from "@/components/search/FilterSidebar";
import ResultsList from "@/components/search/ResultsList";
import SearchBar from "@/components/search/SearchBar";
import { useAuth } from "@/context/AuthContext";
import { SearchProvider } from "@/context/SearchContext";
import { useState } from "react";

export default function SearchResultsPage() {
  const { user } = useAuth();
  const [authModalOpen, setAuthModalOpen] = useState(false);

  return (
    <SearchProvider>
      <div className="min-h-screen flex flex-col bg-white">
        <Header />
        <main className="flex-grow">
          <div className="flex container mx-auto  min-h-[calc(100vh-130px)]  max-md:px-0">
            <div className="flex-1 bg-red/90  mx-2 overflow-hidden ">
              <div className="h-full overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
                <div className="p-4 max-md:p-0 max-md:px-2">
                  <SearchBar />
                  <ResultsList />
                </div>
              </div>
            </div>
          </div>
        </main>

        <AuthModal
          isOpen={authModalOpen}
          onClose={() => setAuthModalOpen(false)}
          defaultTab="login"
        />
      </div>
    </SearchProvider>
  );
}
